<template>
  <v-card class="mx-auto my-12" max-width="374">
    <v-card-title>Change Password</v-card-title>

    <v-card-text class="pb-0">
      <div class="form-group">
        <label>Password</label>
        <input
          type="password"
          name="password"
          class="form-control"
          v-model="password1"
        />
      </div>
      <div class="form-group">
        <label>Password (Repeat)</label>
        <input
          type="password"
          name="password2"
          class="form-control"
          v-model="password2"
        />
      </div>
    </v-card-text>

    <v-card-actions class="pt-0">
      <button
        class="btn btn-primary w-75"
        style="margin:auto"
        :disabled="password1 != password2"
        @click="doChangePassword"
      >
        Change Password
      </button>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["OTP"],
  name: "ChangePasswordComponent",
  data() {
    return {
      password1: "",
      password2: ""
    };
  },
  methods: {
    ...mapActions("api", [
      "changePassword",
      "handleRequestError",
      "printAlertMessage"
    ]),
    doChangePassword() {
      this.changePassword({ OTP: this.OTP, password: this.password1 })
        .then(resp => {
          this.printAlertMessage(resp.msg);
          this.$router.push("/login");
        })
        .catch(this.handleRequestError);
    }
  }
};
</script>

<style scoped></style>
